<template>
  <TTipbox
    variant="warning"
  >
    <strong>{{ t('crossBorderTravel.text', { country: countryText }) }}</strong>
    <div class="mt-1">
      {{ t('crossBorderTravel.description') }}
      <slot />
    </div>
  </TTipbox>
</template>

<script setup lang="ts">
import type { COUNTRY_SHORTS } from '~/constants'

const props = defineProps<{
  country: COUNTRY_SHORTS
}>()

const { t } = useI18n()

const countryText = computed(() => {
  return t(`crossBorderTravel.countries.${props.country}`)
})
</script>

<i18n lang="json">
{
  "en": {
    "crossBorderTravel": {
      "text": "Crossing the border of {country} is not allowed for this RV.",
      "description": "Unfortunately, you don’t meet the host’s requirements to book this RV.",
      "countries": {
        "CA": "Canada",
        "US": "the United States"
      }
    }
  },
  "fr": {
    "crossBorderTravel": {
      "text": "Les voyages à l’extérieur {country} ne sont pas autorisés pour ce VR.",
      "description": "Malheureusement, vous ne répondez pas aux exigences de l’hôte pour réserver ce VR.",
      "countries": {
        "CA": "du Canada",
        "US": "des États-Unis"
      }
    }
  }
}
</i18n>
